import React from 'react'
import { Typography as MTypography, TypographyProps } from '@mui/material'

interface ExtendedTypographyProps extends TypographyProps {
  disabled?: boolean
}

export const Typography: React.FC<ExtendedTypographyProps> = ({ disabled, ...props }) => {
  const disabledStyle = disabled
    ? {
        color: '#79747E'
      }
    : {}

  return <MTypography {...props} style={{ ...disabledStyle, ...props.style }} />
}
